
import React, { useEffect, useRef, useState } from 'react'


function Dropdown({ children, iconHTML, title, className, width }) {

    const [showdropdown, setShowDropdown] = useState(false)
    const btnRef = useRef()
    const textRef = useRef()

    useEffect(() => {
        const handleClose = (e) => {
            if (e.target.id !== btnRef.current.id && e.target.id !== textRef.current.id) {
                setShowDropdown(false)
            }
        }
        document.body.addEventListener('click', handleClose);
        return () => document.body.removeEventListener("click", handleClose);
    }, [])

    return (
        <div className='flex flex-col items-center'>
            <button ref={btnRef} id={"dropdownBtn"} className={className ? className : 'flex items-center hover:bg-gray-100 hover:text-gray-600 rounded py-2 px-3  gap-3  text-gray-500 cursor-pointer '} onClick={() => setShowDropdown(!showdropdown)} >
                <p id={"dropdownText"} ref={textRef}>{title}</p>
                {iconHTML}

            </button>
            {
                showdropdown && (
                    // top-10 left-[235px] mt-5 
                    <div className={`fixed z-50 mt-10   bg-white shadow rounded-sm mx-auto py-3 px-3 ${width}`}>
                        <div className='flex flex-col' >
                            {children}
                        </div>
                    </div>
                )}
        </div>
    )
}

export default Dropdown